/* VendorResponse.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _22 = "._3zhz1b66._3zhz1b66>span{margin-left:var(--ds-space-050,4px)}";
const _21 = "._4cvr1h6o{align-items:center}";
const _20 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _19 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _18 = "@media not all and (min-width:48rem){._q5ugidpf{margin-top:0}._7tldidpf{margin-right:0}._14adidpf{margin-bottom:0}._4uroidpf{margin-left:0}}";
const _17 = "._otyr1b66{margin-bottom:var(--ds-space-050,4px)}";
const _16 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _15 = "@media not all and (min-width:48rem){._q5ugpxbi{margin-top:var(--ds-space-200,1pc)}}";
const _14 = "._1bsb1osq{width:100%}";
const _13 = "@media not all and (min-width:48rem){._suga1txw{display:flex}._ag851h6o{align-items:center}._1d4sutpp{column-gap:var(--ds-space-150,9pt)}}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LoadingButton } from '@atlaskit/button';
import { media } from '@atlaskit/primitives';
import { BodyNormal } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _12 = "@media not all and (min-width:48rem){._15txfbnq{padding:var(--ds-space-200,1pc) var(--ds-space-150,9pt)}._a5zt1l7b{border-radius:3px}._1j3011bn{background-color:var(--ds-background-accent-gray-subtlest,#f1f2f4)}._1gde1bp4{flex-direction:column}._1d4sidpf{column-gap:0}}";
const _11 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _10 = "._gy1putpp{column-gap:var(--ds-space-150,9pt)}";
const _9 = "._1e0c1txw{display:flex}";
const _8 = "._19bvidpf{padding-left:0}";
const _7 = "._n3tdidpf{padding-bottom:0}";
const _6 = "._u5f3idpf{padding-right:0}";
const _5 = "._ca0qidpf{padding-top:0}";
const _4 = "._18u0idpf{margin-left:0}";
const _3 = "._otyridpf{margin-bottom:0}";
const _2 = "._2hwxidpf{margin-right:0}";
const _ = "._19pkidpf{margin-top:0}";
export const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _gy1putpp _19pkxy5q _15txfbnq _a5zt1l7b _1j3011bn _1gde1bp4 _1d4sidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const Header = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_suga1txw _ag851h6o _1d4sutpp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
export const Content = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _q5ugpxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Content';
}
export const ResponseContent = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ResponseContent.displayName = 'ResponseContent';
}
export const VendorName = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_17, _18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyr1b66 _q5ugidpf _7tldidpf _14adidpf _4uroidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  VendorName.displayName = 'VendorName';
}
export const ActionsContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _20, _9, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulputpp _19pkpxbi _1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionsContainer.displayName = 'ActionsContainer';
}
export const LoadingButtonStyled = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = LoadingButton,
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_3zhz1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LoadingButtonStyled.displayName = 'LoadingButtonStyled';
}